import React from 'react';
import { useLoadContractScreens } from '../../hooks/useLoadContractScreens';
import { TAB_NUMBER } from '../../../ContractScreensView/constants';
import SpinnerLoader from '../../../../components/SpinnerLoader/SpinnerLoader';
import CompletedCycleContractItem from '../CompletedCycleContractItem/CompletedCycleContractItem';
import { useCompletedCycles } from './hooks/useCompletedCycles';
import filterCyclesByContract from '../../utils/getCyclesByContract';

const CompletedCycleContractList: React.FC = () => {
  const { contracts, isLoading: isLoadingContractData } = useLoadContractScreens({ tabNumber: TAB_NUMBER.COMPLETED });
  const { cycles } = useCompletedCycles();

  if (!contracts.length && isLoadingContractData) {
    return (
      <div className="flex flex-row items-center justify-center">
        <SpinnerLoader />
      </div>
    );
  }

  if (!contracts.length && !isLoadingContractData) {
    return null;
  }

  return (
    <ul className='c-completed-list-cycle-contract-list flex flex-col gap-y-1 pb-1'>
      {contracts.map((contract) => (
        <CompletedCycleContractItem
          key={contract.id}
          contractId={contract.id}
          contractName={contract.name}
          cycles={filterCyclesByContract(cycles, contract.id)}
        />
      ))}
    </ul>
  );
};

export default CompletedCycleContractList;